export const toCapitalize = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export function compare(s1: string, s2: string): number {
  if (s1 > s2) {
    return 1;
  }
  if (s1 < s2) {
    return -1;
  }
  // a must be equal to b
  return 0;
}
